import React from 'react';

const PageBar = ({setView, setShowAddModule}) => <div className="coxswain coxswain-bar coxswain-editpage-bar">
  <a href="#seo" onClick={e => {e.preventDefault(); setView('seo_meta')}}>SEO</a>
  <a href="#custom-scripts" onClick={e => {e.preventDefault(); setView('customscripts')}}>Custom Scripts</a>
  <a href="#custom-styles" onClick={e => {e.preventDefault(); setView('customstyles')}}>Custom Styles</a>
  <a onClick={ e => {e.preventDefault(); setShowAddModule(true)}} id="coxswainaddmodule" href="">Add Module To Page</a>
</div>;

export default PageBar;